import { StoreProductField } from 'app/models/types/store/product';

const ONE_LIST_LIMIT = 7;
const SPLIT_LIMIT = 5;

export const splitProductsForPopup = (allProducts: Partial<StoreProductField['types']>) => {
  const allProductsLength: number = Object.keys(allProducts).length;

  if (allProductsLength <= ONE_LIST_LIMIT) {
    return {
      mainProducts: allProducts,
      extendedProducts: {},
    };
  }

  const mainProducts = {};
  const extendedProducts = {};
  const allProductsKeys = Object.keys(allProducts);

  for (let i = 0; i < allProductsKeys.length; i++) {
    const key: string = allProductsKeys[i];
    if (i < SPLIT_LIMIT) {
      mainProducts[key] = allProducts[key];
    } else {
      extendedProducts[key] = allProducts[key];
    }
  }

  return {
    mainProducts,
    extendedProducts,
  };
};
